<template>
    <div class="c-airline taskMap">
        <div class="c-airline__main" :style="'left: 8px;width: calc(100% - 18px);'">
            <div class="c-airline__left" :style="'width:324px;display: block;'">
                <Left @showAddAndEditor="showTaskAddor($event)" @showPageIndex="showPageIndex($event)"
                    @taskHandle="taskHandle($event)" :refresh="isRefresh" :modelData="modelData" />
            </div>
            <div class="c-airline__content" :style="'left: 330px; width:calc(100% - 324px - 15px);'">
                <component v-bind:is="components.Map"></component>
            </div>
        </div>
        <div v-if="taskadd">
            <TaskAdd @save="saveData" :taskTitle="taskTitle" :taskId="taskId" />
        </div>
        <div v-if="resultShow" class="result-task">
            <TaskResult @dialogClose="dialogClose" @refresh="updateTaskData" :stopStatus="stopStatus"
                :data="ResultDataObj" />
        </div>
        <div class="eventhandle" v-if="dialogVisible">
            <el-dialog custom-class="addTask" :title="dialogTitle" :close-on-click-modal="false"
                :visible="dialogVisible" :show-close="false">
                <el-form ref="taskFormRef" :model="taskform" :rules="rules" label-width="80px">
                    <el-row :gutter="30" v-if="dialogtaskType === 'confirmTask'">
                        <el-col :span="24" style="color: #fff">
                            {{ $t('taskPage.taskMap.confirmExecution') }}</el-col>
                        <el-col :span="24" style="margin-top: 14px"><el-form-item
                                :label="$t('taskPage.taskMap.confirmPassword')" prop="checkPassword">
                                <el-input v-model="taskform.checkPassword"
                                    :placeholder="$t('taskPage.taskMap.inputConfirmPassword')" />
                            </el-form-item></el-col>
                    </el-row>
                    <el-row :gutter="30" v-if="dialogtaskType === 'compeleteTask'">
                        <el-col :span="24" style="color: #fff">
                            {{ $t('taskPage.taskMap.confirmEndTask') }}</el-col>
                        <!-- <el-col :span="24" style="margin-top: 14px"
                            ><el-form-item label="确认密码" prop="checkPassword">
                            <el-input
                                v-model="taskform.checkPassword"
                                placeholder="请输入确认密码	"
                            /> </el-form-item
                        ></el-col> -->
                    </el-row>
                    <el-row :gutter="30" v-if="dialogtaskType === 'overTask'">
                        <el-col :span="24" style="color: #fff"> {{ $t('taskPage.taskMap.confirmTaskCompleted')
                            }}</el-col>
                    </el-row>
                    <el-row :gutter="30" v-if="dialogtaskType === 'endTask'">
                        <el-col :span="24" style="color: #fff">
                            {{ $t('taskPage.taskMap.confirmTerminateTask') }}</el-col>
                        <!-- <el-col :span="24" style="margin-top: 14px" >
                            <el-form-item label="确认密码" prop="checkPassword">
                            <el-input v-model="taskform.checkPassword" placeholder="请输入确认密码	" />
                            </el-form-item >
                        </el-col> -->
                        <el-col :span="24" style="margin-top: 14px">
                            <el-form-item :label="$t('taskPage.taskMap.terminateReason')" style="font-size: 1px"
                                prop="stopReason">
                                <el-input v-model="taskform.stopReason"
                                    :placeholder="$t('taskPage.taskMap.inputTerminateReason')" type="textarea" />
                            </el-form-item></el-col>
                    </el-row>
                    <el-col :span="24">
                        <div class="dialog__footer"
                            style="margin: 5px 0; clear: both; overflow: hidden; text-align: center">
                            <el-button class="cancel" @click="taskClose">{{ $t('taskPage.taskMap.cancel') }}
                            </el-button>
                            <el-button plain class="save" @click="passTask">{{ $t('taskPage.taskMap.confirm')
                                }}</el-button>
                        </div>
                    </el-col>
                </el-form>

                <img class="fix-close" v-if="dialogVisible" src="../imgs/icon_关闭.png"
                    :alt="$t('taskPage.taskMap.close')" @click="taskClose" />
            </el-dialog>
        </div>
    </div>
</template>

<script>
import VXETable from 'vxe-table';

import createModule from './modules';
import TaskAdd from '../common/taskAdd.vue';
import TaskResult from '../common/TaskResult.vue';
import Left from './Left.vue';
import api from '../api';

export default {
    components: { TaskAdd, Left, TaskResult },
    name: 'task-map',
    provide() {
        return {
            modules: this.modules,
        };
    },
    props: {
        modelData: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        document.title = this.$t('taskPage.taskMap.taskName');
        let that = this;

        let delegate = {
            refreshTableData: false,
        };
        const { MainModule } = createModule(delegate);
        return {
            components: {
                Map: MainModule.outputAsComponent.map,
            },

            modules: Object.freeze({ MainModule }),
            showPage: false,
            taskadd: false,
            taskTitle: 1,
            taskId: '',
            dialogVisible: false,
            dialogTitle: '',
            dialogtaskType: '',
            isRefresh: false,
            resultShow: false,
            stopStatus: false,
            taskform: {
                checkPassword: '',
                id: '',
                executeTime: '',
                remark: '',
            },
            rules: {
                checkPassword: [{ required: true, message: this.$t('taskPage.taskMap.confirmPasswordEmpty'), trigger: 'blur' }],
                stopReason: [{ required: true, message: this.$t('taskPage.taskMap.terminateReasonEmpty'), trigger: 'blur' }],
            },
            ResultDataObj: {
                id: '',
                taskStatus: '',
                type: 0,
                stopRead: '',
            },
        };
    },
    methods: {
        dialogClose() {
            this.ResultDataObj = {};
            this.resultShow = false;
        },
        saveData() {
            this.taskadd = false;
            this.isRefresh = !this.isRefresh;
        },
        ConfirmTask(el) {
            this.dialogVisible = true;
            this.dialogtaskType = 'confirmTask';
            this.dialogTitle = this.$t('taskPage.taskMap.confirmPassword');
            this.taskform.id = el.id;
        },
        taskStop(el) {
            this.dialogVisible = true;
            this.dialogtaskType = 'endTask';
            this.dialogTitle = this.$t('taskPage.taskMap.terminateTask');
            this.taskform.id = el.id;
        },
        taskClose() {
            this.dialogVisible = false;
        },
        taskcompelete(el) {
            this.dialogVisible = true;
            this.dialogtaskType = 'compeleteTask';
            this.dialogTitle = this.$t('taskPage.taskMap.completeTask');
            this.taskform.id = el.id;
        },
        async passTask() {
            switch (this.dialogtaskType) {
                case 'confirmTask':
                    await api.startTask(this.taskform).then((res) => {
                        if (res.code == 200) {
                            this.dialogVisible = false;
                            this.dialogtaskType = '';
                            this.dialogTitle = '';
                            this.$message.success(this.$t('taskPage.taskMap.confirmTaskSuccess'));
                            this.resetdialog();
                            this.isRefresh = !this.isRefresh;
                        } else {
                            this.$message.error(`${res.msg}`);
                        }
                    });
                    break;
                case 'compeleteTask':
                    await api.compeleteTask(this.taskform).then((res) => {
                        if (res.code == 200) {
                            this.dialogVisible = false;
                            this.dialogtaskType = '';
                            this.dialogTitle = '';
                            this.isRefresh = !this.isRefresh;

                            this.$message.success(this.$t('taskPage.taskMap.endTaskSuccess'));
                            this.resetdialog();
                        } else {
                            this.$message.error(`${res.msg}`);
                        }
                    });
                    break;
                case 'endTask':
                    await api.endTask(this.taskform).then((res) => {
                        if (res.code == 200) {
                            this.dialogVisible = false;
                            this.dialogtaskType = '';
                            this.dialogTitle = '';
                            this.isRefresh = !this.isRefresh;

                            this.$message.success(this.$t('taskPage.taskMap.terminateTaskSuccess'));
                            this.resetdialog();
                        } else {
                            this.$message.error(`${res.msg}`);
                        }
                    });
                    break;
                case 'overTask':
                    await api.overTask(this.taskform).then((res) => {
                        if (res.code == 200) {
                            this.dialogVisible = false;
                            this.dialogtaskType = '';
                            this.dialogTitle = '';
                            this.isRefresh = !this.isRefresh;

                            this.$message.success(this.$t('taskPage.taskMap.completeUploadSuccess'));
                            this.resetdialog();
                        } else {
                            this.$message.error(`${res.msg}`);
                        }
                    });
                    break;

                default:
                    break;
            }
        },
        taskOver(el) {
            this.dialogVisible = true;
            this.dialogtaskType = 'overTask';
            this.dialogTitle = this.$t('taskPage.taskMap.completeUpload');
            this.taskform.id = el.id;
        },
        taskStop(el) {
            this.dialogVisible = true;
            this.dialogtaskType = 'endTask';
            this.dialogTitle = this.$t('taskPage.taskMap.terminateTask');
            this.taskform.id = el.id;
        },
        taskEnd(el) {
            this.dialogVisible = true;
            this.dialogtaskType = 'compeleteTask';
            this.dialogTitle = this.$t('taskPage.taskMap.endTask');
            this.taskform.id = el.id;
        },
        resetdialog() {
            this.taskform = {};
        },
        taskHandle(el) {
            console.log(el, 'el');
            switch (el.eve) {
                case 'taskOver':
                    this.taskOver(el.data);
                    break;
                case 'confirmTask':
                    this.ConfirmTask(el.data);
                    break;
                case 'taskEnd':
                    this.taskEnd(el.data);
                    break;
                case 'taskStop':
                    this.taskStop(el.data);
                    break;

                default:
                    break;
            }
        },
        updateTaskData() {
            this.isRefresh = !this.isRefresh;
        },
        showPageIndex(el) {
            if (el.stop) {
                this.showTaskResult(el);
            }
            //  else {
            //     this.stopStatus = false;
            //     this.taskadd = true;
            //     this.$emit('detail', el);
            // }
        },
        showTaskAddor(el) {
            this.taskadd = true;
            if (el.editor) {
                this.taskTitle = 2;
                this.taskId = el.editor.id;
            } else {
                this.taskTitle = 1;
                this.taskId = '';
            }
        },
        showTaskResult(el) {
            console.log(el, '终止任务原因');
            this.ResultDataObj.stopRead = el.stop.stopReason;
            this.ResultDataObj.type = 2;
            this.resultShow = true;
            this.stopStatus = true;
        },
    },
    created() {
        this.modules.MainModule.getSiteList();
    },
    mounted() {
        // 在mounted 声明周期中创建定时器
        const timer = setInterval(() => {
            // console.log('this.modules', this.modules.MainModule);
            this.modules.MainModule.getSiteList();
        }, 10000);
        // 通过$once来监听定时器，在beforeDestroy钩子可以被清除
        this.$once('hook:beforeDestroy', () => {
            // 在页面销毁时，销毁定时器
            clearInterval(timer);
        });
        // this.$store.dispatch('getPageTaskBtnPer');
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

@include b(airline, c) {
    width: 100%;
    height: calc(100%);
    box-sizing: border-box;
    position: relative;

    @include e(main) {
        position: absolute;
        top: 15px;
        height: calc(100% - 27px);
    }

    @include e(left) {
        position: absolute;
        left: -5px;
        top: 0px;
        width: 330px;
        height: calc(100% - 0px);
        z-index: 0;
        // border: 1px solid hsl(199, 73%, 54%);
        background-color: #071150;
        border-radius: 5px;

        &::after {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            z-index: -2;
            position: absolute;
            top: 0px;
            left: 0px;
            background-color: #071150;
        }

        &::before {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            z-index: -1;
            position: absolute;
            top: 0px;
            left: 0px;
            border: 56px solid;
            box-sizing: border-box;
            border-image: url(./imgs/bg_wrap.png) 56 56;
        }
    }

    @include e(right) {
        position: absolute;
        right: 5px;
        top: 0px;
        // width: 334px;
        height: 100%;
        // border: 1px solid hsl(199, 73%, 54%);
        background-color: #071150;
        border-radius: 5px;

        z-index: 0;
    }

    @include e(content) {
        position: absolute;
        top: 0px;
        width: calc(100% - 330px * 2 - 8px * 2);
        height: calc(100% - 0px);
        padding: 8px;
        // border: 1px solid hsl(199, 73%, 54%);

        background-color: #071150;
        z-index: 0;

        &::after {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            z-index: -2;
            position: absolute;
            top: 0px;
            left: 0px;
            background-color: #071150;
        }

        &::before {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            z-index: -1;
            position: absolute;
            top: 0px;
            left: 0px;
            border: 56px solid;
            box-sizing: border-box;
            border-image: url(./imgs/bg_wrap.png) 56 56;
        }
    }

    .taskDetail {
        z-index: 9999;
        box-sizing: border-box;

        .task_tabs {
            width: 100%;
            height: 48px;
            line-height: 48px;
            font-size: 16px;
            position: relative;
            border: 1px solid #1a47a4;

            img {
                width: 18px;
                height: 18px;
                vertical-align: middle;
                margin-left: 16px;
                margin-top: -4px;
            }

            div {
                text-align: center;
                display: inline-block;
                color: #fff;
                margin-left: 8px;
            }

            .isblue {
                color: #49f0fd;
            }
        }

        .taskAll {
            height: 83vh;
            margin: 8px 0;
            border: 1px solid #1a47a4;
        }
    }
}
</style>

<style lang="scss">
.eventhandle {
    .el-dialog {
        width: 500px;
        height: 300px;
        background: #071150;
        box-shadow: inset 0px 0px 10px 0px #49f0fd;
        opacity: 1;
        border: 1px solid #49f0fd;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .el-dialog__title {
            color: #49f0fd;
        }

        .dialog__footer {
            position: absolute;
            bottom: 20px;
            left: 50%;
            transform: translateX(-50%);

            .el-button {
                width: 100px;
                height: 30px;
            }

            .save {
                color: black;
                background-color: #49f0fd;
                border: 1px solid #49f0fd;
            }

            .cancel {
                background: rgba(73, 240, 253, 0.2);
                border-radius: 2px 2px 2px 2px;
                opacity: 1;
                border: 1px solid #49f0fd;
                color: #49f0fd;
            }
        }

        .fix-close {
            position: absolute;
            top: -20px;
            right: -20px;
            cursor: pointer;
        }
    }

    .el-form-item__label {
        color: #fff;
    }

    .el-input__inner {
        background-color: #071150 !important;
        border: 1px solid rgba(135, 161, 216, 0.7) !important;
        color: #fff !important;
    }
}
</style>
